import {GlobalState} from "../GlobalState";
import NavigationBar from "../NavigationBar";
import React from "react";

import '../App.css';

interface LoginSuccessAppProps {
    setGlobalState : (state: GlobalState) => void;
}

export default function LoginSuccessApp(props: LoginSuccessAppProps) {
    return <div className="App">
        <NavigationBar loggedIn={false}/>
        <h1>LoginSuccess</h1>
    </div>
}